/* /app — role-based entry redirect. Resolves active role and navigates to its home. */

import { useEffect, useMemo } from 'react';
import { useNavigate } from '../lib/routing';
import { toast } from 'sonner';
import { useRoles, ROLE_LABEL } from '../hooks/use-roles';
import { resolveAppDestination } from '../lib/role-home';

export default function AppRedirect() {
  const { activeRole, available, loading } = useRoles();
  const navigate = useNavigate();
  const destination = useMemo(() => resolveAppDestination(activeRole, available), [activeRole, available]);

  useEffect(() => {
    if (loading) return;
    if (activeRole && available.length > 1) {
      toast.info(`Mode actif : ${ROLE_LABEL[activeRole]}`, {
        description: 'Change de mode depuis le sélecteur de rôle du menu.',
        id: 'active-role-notice',
      });
    }
    if (destination.kind === 'pending') navigate('/app/pending', { replace: true });
    else if (destination.kind === 'home') navigate(destination.path, { replace: true });
    else console.error(`[AppRedirect] aucun accueil défini pour le rôle actif « ${activeRole} »`);
  }, [activeRole, available, loading, destination, navigate]);

  if (!loading && destination.kind === 'unmapped') {
    return (
      <div className="flex items-center justify-center min-h-screen p-4 text-center">
        <p className="text-[var(--naia-text-secondary)]">
          Impossible de déterminer votre page d’accueil. Changez de mode depuis le menu ou contactez le support.
        </p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
    </div>
  );
}
